import { useEffect, useState } from "react";
import { useApiData } from "@/contexts/ApiData";
import { useTranslations } from "@/contexts/Translation";
import Section from "@/components/Section";
import { H2 } from "@/components/Headers/Headings";
import AnnouncementItem from "./AnnouncementItem";
import SystemMessage from "@/components/SystemMessage/Index";
import styles from "./Announcements.module.css";

type Announcement = {
  id: string;
  title: string;
  body: string;
  publishedAt: string;
};

const Announcements = () => {
  const { get } = useApiData();
  const t = useTranslations("announcements");
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const data = await get("/announcements");
      if (data) {
        setAnnouncements(data);
      }
      setLoading(false);
    };
    load();
  }, [get]);

  if (loading) {
    return <SystemMessage message='loading' />;
  }

  return (
    <Section>
      <H2>{t("heading")}</H2>
      {announcements.length === 0 ? (
        <div className={styles.empty}>{t("empty")}</div>
      ) : (
        <div className={styles.list}>
          {announcements.map((announcement) => (
            <AnnouncementItem key={announcement.id} title={announcement.title} body={announcement.body} publishedAt={announcement.publishedAt} />
          ))}
        </div>
      )}
    </Section>
  );
};

export default Announcements;
